export const navData = [
  { id: 1, title: "Home", url: "/" },
  { id: 2, title: "About", url: "/About" },
  { id: 3, title: "Services", url: "/Services" },
  { id: 4, title: "Projects", url: "/Projects" },
  { id: 5, title: "Contact", url: "/Contact" }
];
